import api from "../api/api";

export const statisticService = {
    getDashboardStats: async () => {
        const response = await api.get("/admin/statistic/dashboard");
        return response;
    },
};
